import { DEFAULT_IMPACT, DEFAULT_STATUS } from '@/constants/initiative'

/**
 * This takes KR object and initiative title, and returns an object that can be used as a payload to create Initiative.
 * @param kr
 * @param title
 * @returns {{krId, goalId, impact: string, title, ownerId, orgId, coOwnerIds: *[], status: string}}
 */
export default (kr, title, orgId, projectId) => {
  return {
    orgId,
    goalId: kr?.goalId,
    krId: kr?.id,
    projectId: projectId,
    title,
    ownerId: kr?.ownerId,
    coOwnerIds: [],
    impact: DEFAULT_IMPACT,
    status: DEFAULT_STATUS
  }
}
